import React from 'react';
import useQuery from './use-query';
import {useBuffetState} from '../components/buffet';
import {useSettingsState} from '../components/settings';

const useBuffetStateEx = () => {
    const {defaultServiceId} = useSettingsState();
    const {serviceId = defaultServiceId} = useQuery();
    const buffetState = useBuffetState();
    const cs = React.useMemo(
        () =>  buffetState.filter(e => e.serviceId === serviceId),
        [buffetState, serviceId]
    );
    return cs;
};

export default useBuffetStateEx;